<template>
  <v-footer class="footer mt-2" style="z-index:100">
    <v-card
      color="#2196F3"
      dark
      padless
      style="width: 100%"
    >
      <div>
        <div style="display:flex; justify-content:center;">
            Made with&nbsp
            <v-icon class="heart" small color="red">fas fa-heart</v-icon>&nbspby&nbspMidhun
            Nair</div>
            <div style="display:flex; justify-content:center;">
            &copy; {{ new Date().getFullYear() }} - All rights reserved
            </div>
      </div>
    </v-card>
  </v-footer>
</template>

<script>
export default {};
</script>

<style scoped>
.footer:hover .heart{
  animation: beat 0.4s infinite;
  }
  @keyframes beat{
    from{
      transform: scale(1.2);
    }
    to{
      transform: scale(1);
    }  
  }
</style>